// extracted by mini-css-extract-plugin
export default {"container":"AssignInfo_container__12aQi","assignBtn":"AssignInfo_assignBtn__7TB6X"};